import React from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function PlanCard({ plan }) {
  const { user } = useAuth();

  const isCurrentPlan =
    user?.membership_plan === plan.name;

const paymentLinks = {
  79: "https://www.paypal.com/ncp/payment/3E8LMGZC6R7GA",
  149: "https://www.paypal.com/ncp/payment/HPAUYB5PRB546",
  199: "https://www.paypal.com/ncp/payment/B29DGYG2ZDN2Q",
  299: "https://www.paypal.com/ncp/payment/N82Y9BAPY4G7Q",
};



  const paymentLink = paymentLinks[Number(plan.price)];

  const durationByPrice = {
    79: "1 Month",
    149: "3 Months",
    199: "6 Months",
    299: "12 Months",
  };

  const duration =
    plan.duration_label ||
    durationByPrice[Number(plan.price)] ||
    "";

  const fallbackFeatures = {
    79: [
      "Core dashboard access",
      "Daily stock picks",
      "Standard signal alerts",
      "Basic market overview",
      "Basic technical indicators",
      "Limited watchlist",
      "Monthly market insights",
      "Email support",
    ],

    149: [
      "Everything in Starter",
      "Premium signal alerts",
      "Advanced technical analysis",
      "RSI, MACD & Moving Averages",
      "Support & Resistance levels",
      "Weekly market briefing",
      "Expanded watchlist",
      "Priority email support",
    ],

    199: [
      "Everything in Growth",
      "AI-driven stock picks",
      "AI market predictions",
      "Advanced stock analytics",
      "Portfolio tracking",
      "Risk scoring",
      "Market trend analysis",
      "More frequent signals",
      "VIP chat support",
    ],

    299: [
      "Everything in Premium",
      "Personal advisor 1-on-1",
      "Advanced AI market insights",
      "Unlimited dashboard access",
      "Advanced portfolio analytics",
      "Priority market alerts",
      "Personalized stock analysis",
      "Exclusive market reports",
      "24/7 concierge support",
    ],
  };

  const features =
    plan.features?.length > 0
      ? plan.features
      : fallbackFeatures[Number(plan.price)] || [];

  const handleChoosePlan = async () => {
    try {
      const res = await api.post("/membership/purchase", {
        plan_id: plan.id,
      });

      const data = res.data;

      if (data.ok) {
        localStorage.setItem(
          "payment_id",
          data.payment_id
        );

        window.location.href = paymentLink;
      }
    } catch (error) {
      console.log(error);

      toast.error(
        "Unable to start payment"
      );
    }
  };

  return (
    <div className="card-tactical rounded-xl p-6 border border-white/10 flex flex-col">

      {/* Plan Name */}
      <h3 className="font-heading font-bold text-xl mb-2">
        {plan.name}
      </h3>

      {/* Description */}
      <p className="text-white/60 text-sm mb-4">
        {plan.description}
      </p>

      {/* Price + Duration */}
      <div className="text-3xl font-bold text-volt mb-4">
        ${plan.price}

        <span className="text-base font-medium text-white/60 ml-2">
          / {duration}
        </span>
      </div>

      {/* Credits */}
      <div className="text-white/60 text-sm mb-5">
        Credits: {plan.credits}
      </div>

      {/* Features */}
      <div className="space-y-3 mb-6 flex-1">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex items-start gap-2 text-sm text-white/80"
          >
            <span className="text-[#0070ba] font-bold">
              ✓
            </span>

            <span>
              {feature}
            </span>
          </div>
        ))}
      </div>




      {/* Button */}
      <button
        onClick={() => {
          if (!isCurrentPlan) {
            handleChoosePlan();
          }
        }}
        disabled={isCurrentPlan}
        className={`w-full py-3 rounded-lg font-semibold transition ${
          isCurrentPlan
            ? "bg-green-600 text-white cursor-default"
            : "bg-[#0070ba] hover:bg-[#005ea6] text-white"
        }`}
      >
        {isCurrentPlan
          ? "Current Plan"
          : "Upgrade / Choose Plan"}
      </button>

    </div>
  );
}
